import {connect} from 'react-redux';
import {Stopper as Component} from './Stopper';
import {
  createStopper,
  pushInteractions,
  setHeldObject,
  setHeld,
  setStoppersInScene,
  setStopperHeld,
  setStopperControlVisibility,
  hideAllControls,
  glassTubeItemDrop
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("stoppers") &&
     state.notebook.protocolSection.scene.apparatus.stoppers.some(
       box => box.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.stoppers[ownProps.id-1].type,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.stoppers[ownProps.id - 1].controlsVisible,
      lastDrop: state.notebook.protocolSection.scene.lastDrop,
      heldObject: state.notebook.protocolSection.scene.heldObject,
      inScene: state.notebook.protocolSection.scene.apparatus.stoppers[ownProps.id-1].inScene,
      interactionProps: {
        glassTubes: state.notebook.protocolSection.scene.apparatus.glassTubes,
      },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createStopper: (data)=>{
      dispatch(createStopper(data))
    },
    setStopperControlVisibility: (data) => {
      dispatch(setStopperControlVisibility(data))
    },
    setStoppersInScene: (data) => {
      dispatch(setStoppersInScene(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setStopperHeld: (data) => {
      dispatch(setStopperHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    onDropStopper: (data)=>{
      dispatch(glassTubeItemDrop(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
  };
}

export const Stopper = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
